import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";

import DoulaHeader from "./Header/DoulaHeader";

import {
	Calendar,
	MessageSquare,
	DollarSign,
	HelpCircle,
} from "lucide-react";
import DoulaFooter from "./Footer/DoulaFooter";

interface DoulaLayoutProps {
	children: React.ReactNode;
}
export default function DoulaLayout({ children }: DoulaLayoutProps) {
	const { signOut } = useAuth();
	const navigate = useNavigate();

	const handleSignOut = async () => {
		await signOut();
		navigate("/");
	};

	const navigation = [
		{ name: "Appointments", href: "/doula-appointments", icon: Calendar },
		{ name: "Messages", href: "/doula-messages", icon: MessageSquare },
		{ name: "Earnings", href: "/doula-earnings", icon: DollarSign },
		{ name: "FAQ", href: "/doula-faq", icon: HelpCircle },
	];

	const footerMenuItems = [
		{ title: "Appointments", href: "/doula-appointments" },
		{ title: "Messages", href: "/doula-messages" },
		{ title: "Earnings", href: "/doula-earnings" },
		{ title: "FAQ", href: "/doula-faq" },
	];

	return (
		<div className="min-h-screen bg-gray-50 pb-20 lg:pb-0">
			{/* Sticky Glassy Header */}
			<DoulaHeader navigation={navigation} onHandleSignOut={handleSignOut} />

			{/* Main Content */}
			<main className="pt-16">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
					{children}
				</div>
			</main>

			<DoulaFooter doulaMenuItems={footerMenuItems} />
		</div>
	);
};